<template>
  <BaseAction>
    <SecondaryButton @click.native="openDialog" textColor="#0965dc">
      <v-icon>
        mdi-menu
      </v-icon>
      View Interview Formats
    </SecondaryButton>
    <InterviewFormatListDialog
      @close="closeDialog"
      :isOpen="isOpen"
      v-if="isOpen"
    />
  </BaseAction>
</template>

<script>
import SecondaryButton from "@/components/common/Button/SecondaryButton";
import InterviewFormatListDialog from "@/views/bookings/BookingInterviews/components/InterviewFormatListDialog";
import BaseAction from "@/components/common/BaseAction";

export default {
  name: "ViewInterviewFormatListAction",
  components: {
    InterviewFormatListDialog,
    SecondaryButton,
    BaseAction
  },
  data() {
    return {
      isOpen: false
    };
  },
  methods: {
    openDialog() {
      this.isOpen = true;
    },
    closeDialog() {
      this.isOpen = false;
    }
  }
};
</script>
